import { makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Grid } from "@mui/material";
import jwt_decode from "jwt-decode";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import { getBlackListType } from "../../slices/BlacklistType/BlacklistTypeSlice";
import { blacklistVisitor } from "../../slices/BlacklistVisitor/BlacklistVisitorSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      maxWidth: "600px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function BlockVisitorForm(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [blacklistData, setBlacklistData] = useState([]);
  const [restrictReasonType, setRestrictReasonType] = useState(null);
  const [restrictReason, setRestrictReason] = useState();
  const [restrictReasonTypeTd, setRestrictReasonTypeId] = useState();
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const [payload, setPayload] = useState({
    visitId: props.BlacklistVisitorId,
    restrictedBy: decoded_jwtToken.firstName + " " + decoded_jwtToken.lastName,
    restrictReasonType: "",
    restrictReason: props.restrictReason,
    module: props?.module,
    restrictTypeName: "",
    subModule: props?.subModule,
    name: props?.blockListName,
  });

  const [error, setError] = React.useState({
    restrictReasonType: false,
    restrictReason: false,
    removeAccess: false,
  });

  const [removeAccess, setRemoveAccess] = useState(props.removeAccess);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };
  useEffect(() => {
    setPayload({
      ...payload,
      restrictReasonType: restrictReasonTypeTd,
      restrictReason: props.restrictReason,
    });
  }, [restrictReasonType]);

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(restrictReasonTypeTd)) {
      Toast(t("VISSTATUST"), "error");
      setError({ restrictReasonType: true });
      return;
    }

    if (CommonUtil.isEmptyString(payload.restrictReason)) {
      Toast(t("VISSTATUST1"), "error");
      setError({ restrictReason: true });
      return false;
    }

    dispatch(blacklistVisitor(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAE1046") {
          Toast(t("COMMON073"), "success");
          props.disable();
          handleClose();
        } else if (data.code === "CVAE1049") {
          Toast(data.message, "success");
          props.disable();
          handleClose();
        } else {
          Toast(data.message, "error");
          handleClose();
        }
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    loadBlacklistType();
  };

  const loadBlacklistType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
    };

    dispatch(getBlackListType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setBlacklistData(data.data.purposeTypes);
        } else {
          setBlacklistData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    const defaultValue = blacklistData.find(
      (value) => value.id === props.restrictReasonType
    );
    if (defaultValue?.id) {
      setRestrictReasonType(defaultValue);
      setRestrictReasonTypeId(defaultValue.id);
      setPayload({
        ...payload,
        restrictReasonType: defaultValue.id,
        restrictTypeName: defaultValue.name,
      });
    }
  }, [props.restrictReasonType, blacklistData]);

  return (
    <>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {process.env.REACT_APP_ENVIRONMENT === "USA"
              ? t("BLOCKEDVIS004")
              : "Block Visitor"}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON035")}
        cancelText={t("dataTableCancel")}
        style={{ color: "#3D4977", opacity: 1, minHeight: "" }}
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{
            width: "100%",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid item xs={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              style={{
                width: "100%",
              }}
              noOptionsText={"No Options found"}
              name="restrictReasonType"
              value={restrictReasonType}
              options={blacklistData}
              getOptionLabel={(option) => (option.name ? option.name : "")}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setPayload({
                    ...payload,
                    restrictReasonType: newValue.id,
                    restrictReasonName: newValue.name,
                  });
                  setRestrictReasonTypeId(newValue.id);
                  setRestrictReasonType(newValue);
                } else {
                  setPayload({
                    ...payload,
                    restrictReasonType: "",
                    restrictTypeName: "-",
                  });
                  setRestrictReasonType();
                  setRestrictReasonTypeId("");
                }
              }}
              renderInput={(params) => (
                <CustomTextfield
                  required={true}
                  {...params}
                  name="Blacklist Type"
                  error={error.restrictReasonType}
                  variant="outlined"
                  fullWidth
                  label={"Blocklist Type"}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextfield
              type={"text"}
              label={t("BLOCKEDVIS006")}
              error={error.restrictReason}
              name="restrictReason"
              value={payload.restrictReason}
              handleChange={(e) => handleChange(e)}
              inputProps={{ maxLength: 120 }}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
